import React from "react";
import ImageWithTag from "./ImageWithTag";

function Block5() {
  return (
    <>
      <div className="bg-red- cursor-pointer">
        <ImageWithTag />
        <div className="text-lg pt-2 font-medium text-black">
          Urban Kitchen with Granite Tops, Exposed Bulb Lights and Island
        </div>

        {/* Author + Date */}
        <div className="flex flex-row  pt-3">
          {/* Author */}
          <div className="text-xs-s font-bold">God Of Thunder</div>
          {/* Date */}
          <div className="text-xs-s font-semibold text-gray-400 ml-4">
            August 7, 2021
          </div>
        </div>
      </div>
    </>
  );
}

export default Block5;
